// TODO: remove them all

function getPage() {
  let path = window.location.pathname.split("/");
  return path[path.length - 1];
}

function getTimezoneOffset() {
  return new Date().getTimezoneOffset();
}

function getCsrfToken() {
  return document.querySelector('meta[name="csrf-token"]').content;
}

export { getPage, getTimezoneOffset, getCsrfToken };
